// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  updatePrivacy,
  generateHelpCenterToken,
  getPlayerAccountState,
  getBrandControls,
  createControl,
  removeControlFromAccount,
  addControlToAccount,
  getAccountDetails,
  getControl,
  getAccountDetails1,
  getAccountControlsHistory,
  getAccountControls,
  getAccountCapabilities,
  searchAccount,
} from '../sdk.gen'
import { type UseMutationOptions, queryOptions } from '@tanstack/react-query'
import type {
  UpdatePrivacyData,
  UpdatePrivacyError,
  UpdatePrivacyResponse,
  GenerateTokenData,
  GenerateTokenError,
  GenerateTokenResponse,
  GetStateData,
  GetBrandControlsData,
  CreateControlData,
  CreateControlError,
  CreateControlResponse,
  RemoveControlFromAccountData,
  RemoveControlFromAccountError,
  RemoveControlFromAccountResponse,
  AddControlToAccountData,
  AddControlToAccountError,
  AddControlToAccountResponse,
  GetAccountDetailsData,
  GetControlData,
  GetAccountDetails1Data,
  GetAccountControlsHistoryData,
  GetAccountControlsData,
  GetAccountCapabilitiesData,
  SearchAccountData,
} from '../types.gen'
import { client as _heyApiClient } from '../client.gen'

export const updatePrivacyMutation = (
  options?: Partial<Options<UpdatePrivacyData>>,
): UseMutationOptions<
  UpdatePrivacyResponse,
  UpdatePrivacyError,
  Options<UpdatePrivacyData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePrivacyResponse,
    UpdatePrivacyError,
    Options<UpdatePrivacyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updatePrivacy({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const generateHelpCenterTokenQueryKey = (
  options?: Options<GenerateTokenData>,
) => createQueryKey('generateToken', options)

export const generateHelpCenterTokenOptions = (
  options?: Options<GenerateTokenData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await generateHelpCenterToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: generateHelpCenterTokenQueryKey(options),
  })
}

export const generateHelpCenterTokenMutation = (
  options?: Partial<Options<GenerateTokenData>>,
): UseMutationOptions<
  GenerateTokenResponse,
  GenerateTokenError,
  Options<GenerateTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateTokenResponse,
    GenerateTokenError,
    Options<GenerateTokenData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await generateHelpCenterToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getPlayerAccountStateQueryKey = (
  options?: Options<GetStateData>,
) => createQueryKey('getState', options)

export const getPlayerAccountStateOptions = (
  options?: Options<GetStateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayerAccountState({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPlayerAccountStateQueryKey(options),
  })
}

export const getBrandControlsQueryKey = (
  options: Options<GetBrandControlsData>,
) => createQueryKey('getBrandControls', options)

export const getBrandControlsOptions = (
  options: Options<GetBrandControlsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBrandControls({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBrandControlsQueryKey(options),
  })
}

export const createControlQueryKey = (options: Options<CreateControlData>) =>
  createQueryKey('createControl', options)

export const createControlOptions = (options: Options<CreateControlData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createControl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createControlQueryKey(options),
  })
}

export const createControlMutation = (
  options?: Partial<Options<CreateControlData>>,
): UseMutationOptions<
  CreateControlResponse,
  CreateControlError,
  Options<CreateControlData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateControlResponse,
    CreateControlError,
    Options<CreateControlData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createControl({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const removeControlFromAccountQueryKey = (
  options: Options<RemoveControlFromAccountData>,
) => createQueryKey('removeControlFromAccount', options)

export const removeControlFromAccountOptions = (
  options: Options<RemoveControlFromAccountData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await removeControlFromAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: removeControlFromAccountQueryKey(options),
  })
}

export const removeControlFromAccountMutation = (
  options?: Partial<Options<RemoveControlFromAccountData>>,
): UseMutationOptions<
  RemoveControlFromAccountResponse,
  RemoveControlFromAccountError,
  Options<RemoveControlFromAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveControlFromAccountResponse,
    RemoveControlFromAccountError,
    Options<RemoveControlFromAccountData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await removeControlFromAccount({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const addControlToAccountQueryKey = (
  options: Options<AddControlToAccountData>,
) => createQueryKey('addControlToAccount', options)

export const addControlToAccountOptions = (
  options: Options<AddControlToAccountData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addControlToAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addControlToAccountQueryKey(options),
  })
}

export const addControlToAccountMutation = (
  options?: Partial<Options<AddControlToAccountData>>,
): UseMutationOptions<
  AddControlToAccountResponse,
  AddControlToAccountError,
  Options<AddControlToAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    AddControlToAccountResponse,
    AddControlToAccountError,
    Options<AddControlToAccountData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addControlToAccount({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAccountDetailsQueryKey = (
  options: Options<GetAccountDetailsData>,
) => createQueryKey('getAccountDetails', options)

export const getAccountDetailsOptions = (
  options: Options<GetAccountDetailsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccountDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccountDetailsQueryKey(options),
  })
}

export const getControlQueryKey = (options: Options<GetControlData>) =>
  createQueryKey('getControl', options)

export const getControlOptions = (options: Options<GetControlData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getControlQueryKey(options),
  })
}

export const getAccountDetails1QueryKey = (
  options: Options<GetAccountDetails1Data>,
) => createQueryKey('getAccountDetails1', options)

export const getAccountDetails1Options = (
  options: Options<GetAccountDetails1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccountDetails1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccountDetails1QueryKey(options),
  })
}

export const getAccountControlsHistoryQueryKey = (
  options: Options<GetAccountControlsHistoryData>,
) => createQueryKey('getAccountControlsHistory', options)

export const getAccountControlsHistoryOptions = (
  options: Options<GetAccountControlsHistoryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccountControlsHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccountControlsHistoryQueryKey(options),
  })
}

export const getAccountControlsQueryKey = (
  options: Options<GetAccountControlsData>,
) => createQueryKey('getAccountControls', options)

export const getAccountControlsOptions = (
  options: Options<GetAccountControlsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccountControls({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccountControlsQueryKey(options),
  })
}

export const getAccountCapabilitiesQueryKey = (
  options: Options<GetAccountCapabilitiesData>,
) => createQueryKey('getAccountCapabilities', options)

export const getAccountCapabilitiesOptions = (
  options: Options<GetAccountCapabilitiesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccountCapabilities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccountCapabilitiesQueryKey(options),
  })
}

export const searchAccountQueryKey = (options?: Options<SearchAccountData>) =>
  createQueryKey('searchAccount', options)

export const searchAccountOptions = (options?: Options<SearchAccountData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: searchAccountQueryKey(options),
  })
}
